<p-tabs
    #pTabs
    [value]="tabsArraySig()[activeIndex]?.hide ? 0 : activeIndex"
    (valueChange)="onActiveIndexChange($event)"
    scrollable
>
    <p-tablist #tabView class="overflow-hidden">
        @for (field of this.tabsArraySig(); track $index) {
            <p-tab
                #tab
                [disabled]="field.props?.tabDisabled"
                [value]="$index"
                *ngIf="evaluateHideByField(field)"
                betaFeature
                [betaFeatureField]="field"
                (click)="onLayoutEditTabHeaderClick($event, field, $index)"
            >
                <!-- Disabled p-tab has pointer-events:none; inner host restores hover for tooltip. -->
                <span
                    class="inline-flex items-center !pointer-events-auto"
                    [pTooltip]="field.props?.hint ? (field.props.hint | translate) : null"
                    tooltipPosition="bottom"
                    [appendTo]="'body'"
                    (click)="field.props?.tabDisabled && $event.stopPropagation()"
                >
                    <span
                        *ngIf="field.props.icon"
                        style="margin-right: 3pt"
                        [class]="field.props.icon"
                        [attr.data-testid]="getTabDataTestId($index)"
                    >
                    </span>
                    <span
                        [class]="(field.props?.headerClasses || 'h6') + ' text-nowrap flex items-center gap-2'"
                        [ngClass]="getClasses(tab, field)"
                        [attr.data-testid]="getTabDataTestId2($index, getTabTitle(field))"
                    >
                        {{ getTabTitle(field) }}
                        @if (field.props?.hasContent) {
                            <span
                                class="w-2 h-2 bg-primary-500 rounded-full"
                                [attr.data-testid]="'formly-address-text-content-indicator-' + $index"
                            ></span>
                        }
                    </span>
                    @if (this.tabsWithRequiredFields()[$index]) {
                        <span class="text-red-500 fa-solid fa-asterisk fa-2xs"></span>
                    }
                </span>
            </p-tab>
        }
    </p-tablist>
    <p-tabpanels #tabPanelsRef>
        @for (field of this.tabsArraySig(); track $index) {
            <p-tabpanel #tabPanel [value]="$index">
                <ng-container *ngIf="allowRender2(tabPanel)">
                    <formly-field
                        [field]="field"
                        [class]="isFillHeightTab(field) ? fillHeightFieldClasses : ''"
                    ></formly-field>
                </ng-container>
            </p-tabpanel>
        }
    </p-tabpanels>
</p-tabs>
